const BA = {
  ibanLength: 20,
};
export { BA };
